var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.583,
    height: 13.592,
    viewBox: "0 0 14.583 13.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Out_1920892",
    transform: "translate(17.083 19.392) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(2.5 5.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M31.129,20.6l2.442,2.442H26.245a.845.845,0,1,0,0,1.689h7.341l-2.457,2.442a.847.847,0,1,0,1.2,1.2l3.886-3.886a.835.835,0,0,0,0-1.2L32.327,19.4a.835.835,0,0,0-1.2,0A.862.862,0,0,0,31.129,20.6Z",
    transform: "translate(-21.883 -17.1)",
    fill: "#b93f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M7.614,18.547A.842.842,0,0,0,6.77,17.7H4.189V7.489H6.77a.842.842,0,0,0,.845-.845A.852.852,0,0,0,6.77,5.8H3.345a.842.842,0,0,0-.845.845v11.9a.842.842,0,0,0,.845.845H6.77A.842.842,0,0,0,7.614,18.547Z",
    transform: "translate(-2.5 -5.8)",
    fill: "#b93f3f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.8dbd195c67e2658c64500df8131d4d2c.svg";
export { ForwardRef as ReactComponent };